import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import * as marietta from '../../../';
import { SceneExtrasMaterial } from "../sceneExtrasMaterial";
import { ObjectType } from "../ObjectType";
import * as pscommand from '../../../../marietta/pixelstreaming/commands';

export class ChangeWallMaterial {

    constructor(public wall: THREE.Object3D) {
    }

    protected getTexture(index: number): THREE.Texture {
        return null;
    }

    protected getTextureByName(name: string): THREE.Texture {
        return null;
    }


    protected side(): number {
        return 0;           //内壁０ 外壁1
    }


    protected findObjectsFromGUID(guid: string, isInnerWall: boolean) {
        const result = [];
        ThreeView.get().wcScene.me.traverse((obj) => {
            if ((<THREE.Mesh>obj).isMesh && obj.userData.guid && obj.userData.guid == guid && ObjectType.isInnerWall(obj) == isInnerWall) {
                result.push(obj);
            }
        });
        return result;
    }

    protected updateMaterial(object: THREE.Mesh, texture: THREE.Texture) {
        const guid = object.userData.guid;

        if (guid == null || guid == '') {
            console.warn('guidが正しくありません');

            if (Array.isArray(object.material)) {
                ;
            } else {
                const material = <THREE.MeshStandardMaterial>object.material.clone();
                material.map = texture;
                material.color.setRGB(1.0, 1.0, 1.0, 'srgb');
                object.material = material;
                object.material.needsUpdate = true;
                marietta.webcad.WebCADGlobal.itemManager.updateWallMaterial(this.wall.userData.guid, this.side(), texture.name);
                new SceneExtrasMaterial().updatePointTexture(object.name, texture.name);
                //px連携
                const command = new pscommand.changematerial([{name: object.name, value: texture.name}]);
                ThreeView.get().pscommunication.send(command.object());
            }
            return;
        }

        const meshes = this.findObjectsFromGUID(guid, ObjectType.isInnerWall(object));
        console.assert(meshes.length > 0);

        meshes.forEach((obj) => {
            const material = <THREE.MeshStandardMaterial>obj.material.clone();
            material.color.setRGB(1.0, 1.0, 1.0, 'srgb');
            material.map = texture;
            obj.material = material;
            obj.material.needsUpdate = true;
            new SceneExtrasMaterial().updatePointTexture(obj.name, texture.name);
            //px連携
            const command = new pscommand.changematerial([{name: object.name, value: texture.name}]);
            ThreeView.get().pscommunication.send(command.object());
        });
        marietta.webcad.WebCADGlobal.itemManager.updateWallMaterial(guid, this.side(), texture.name);
    }

    public setMaterial(index: number) {
        this.setTexture(this.getTexture(index));
    }

    public setMaterialByName(name: string) {
        this.setTexture(this.getTextureByName(name));
    }

    private setTexture(texture: THREE.Texture) {
        if (!texture) return;
        const mesh = <THREE.Mesh>this.wall;
        if (!mesh.isMesh) return;
        if (Array.isArray(mesh.material)) {
            ;
        } else {
            this.updateMaterial(mesh, texture);

            // 下がり壁の場合はマテリアル更新は一回のみ
            if (ObjectType.isFalling(mesh) && ObjectType.isFallingWall(mesh)) return;

            const find = this.isWallType(mesh.name) ? this.findkosiNode : this.findwallNode;

            const object =  <THREE.Mesh>find(mesh.name);
            if (object) {
                if (Array.isArray(object.material)) {
                    ;
                } else {
                    this.updateMaterial(object, texture);
                }
            }
        }
    }

    protected isWallType = (name: string): boolean => {
        return name.match(/^out.*-wall.*-node/) != null;
    }

    protected findkosiNode = (name: string): THREE.Object3D => {
        return ThreeView.get().wcItemmgr.houseObjects.getObjectByName(name.replace('wall', 'kosi'));
    }
    protected findwallNode = (name: string): THREE.Object3D => {
        return ThreeView.get().wcItemmgr.houseObjects.getObjectByName(name.replace('kosi', 'wall'));
    }
}
